import { cn } from '@shared/utils/utils';
import * as React from 'react';

type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

const variantClasses: Record<HeadingLevel, string> = {
    h1: 'text-4xl lg:text-5xl',
    h2: 'text-3xl',
    h3: 'text-2xl',
    h4: 'text-xl',
    h5: 'text-lg',
    h6: 'text-base'
};

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
    variant?: HeadingLevel,
    as?: HeadingLevel,
    children: React.ReactNode,
    className?: string
}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
    ({ variant = 'h2', as, className, children, ...props }, ref) => {
        const Comp = as || variant;
        const classes = cn('font-semibold tracking-wide', variantClasses[variant], className);

        return React.createElement(
            Comp,
            { ref, className: classes, ...props },
            children
        );
    }
);

Heading.displayName = 'Heading';

export default Heading;
